import React from "react";
import { Field } from "redux-form";
import { ReduxControls } from "rhombus-react";

import { QATerritories } from "utils/constants";
import { EDIT } from "./helpers";


export const QA = {
	name: "qaLocation",
	label: "Territory",
	placeholder: "Please select a department",
	required: true,
	component: ReduxControls.Select,
	options: QATerritories,
	format(value, name){
		return QATerritories.find(v => v.value === value);
	},
	parse(value){
		return value?.value || null;
	},
};

export default function QALocation({ mode, canSetQa }){
	let isDisabled = false;

	if(!canSetQa){ return null; }

	if(mode === EDIT && canSetQa) {
		isDisabled = true;
	}

	return <Field {...QA} disabled={isDisabled} />;
}

QALocation.defaultProps = {
	canSetQa:false,
	mode:EDIT,
};
